// extracted by mini-css-extract-plugin
export var defaultWrapper = "_my-3";
export var downloadButton = "_my-4";
export var fileContainer = "_my-9 _my-7";
export var fileContainerBase = "_my-7";
export var fileContainerFixedHeight = "_my-8 _my-7";
export var fileInfo = "_my-5";
export var fileInfoWidthRestricted = "_my-6";
export var fileType = "_my-1";
export var fileTypeName = "_my-2";
export var image = "_my-0";
export var link = "_my-b";
export var overflowEllipsis = "_my-a";